<template>
  <span>
    <template v-for="(part, index) in highlightParts" :key="index">
      <em v-if="part.highlighted" class="search-highlight">{{ part.text }}</em>
      <span v-else>{{ part.text }}</span>
    </template>
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { createSafeHighlight } from '@/utils/safeHighlighting'

interface Props {
  text: string
  searchTerm?: string
}

const props = withDefaults(defineProps<Props>(), {
  searchTerm: ''
})

const highlightParts = computed(() => {
  const result = createSafeHighlight(props.text, props.searchTerm)
  return result.parts
})
</script>

<style>
/* Global search highlight styles - no conflicts with other .highlight classes */
.search-highlight,
em.search-highlight {
  background-color: var(--yellow-100, #fef3c7);
  font-style: normal; /* Override default <em> italic styling */
  padding: 0;
  text-decoration: none;
}

/* Prevent link text-decoration from cascading to search highlights */
a .search-highlight,
a em.search-highlight {
  text-decoration: none;
}
</style>
